import * as AvatarPrimitive from '@radix-ui/react-avatar';
import styled, { css } from 'styled-components';

import type { AvatarSize } from '.';

export const RootStyled = styled(AvatarPrimitive.Root)<{ $size: AvatarSize; $outlined?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.typography.caption};
  color: ${({ theme }) => theme.tones.neutral[0]};
  background: ${({ theme }) => theme.colors.neutral.container};
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  ${({ $size }) => {
    switch ($size) {
      case 'small':
        return css`
          width: 24px;
          height: 24px;
        `;

      case 'medium-small':
        return css`
          width: 32px;
          height: 32px;
        `;

      case 'medium':
      default:
        return css`
          width: 40px;
          height: 40px;
        `;
    }
  }}

  ${({ $outlined, theme }) =>
    $outlined &&
    css`
      border: 1px solid ${theme.colors.neutral.background};
    `};
  overflow: hidden;
  flex-shrink: 0;
`;

export const ImageStyled = styled(AvatarPrimitive.Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FallbackStyled = styled(AvatarPrimitive.Fallback)`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: inherit;
  color: inherit;
`;

export const AvatarsGroup = styled.div`
  display: inline-flex;

  & > :not(:first-child) {
    margin-left: -4px;
  }
`;
